import ModalBase from 'components/Luxkit/Modal/ModalBase'
import ModalHeader from 'components/Luxkit/Modal/ModalHeader'
import AspectRatio from 'components/utils/AspectRatio'
import React from 'react'
import { useTranslation } from 'react-i18next'
import Image from 'components/Common/Image/Image'

export enum OfficeLocationsI18Keys {
  MELBOURNE = 'melbourneLocation',
  SYDNEY = 'sydneyLocation',
  CHADSTONE ='chadstoneLocation',
  SINGAPORE = 'singaporeLocation',
  LONDON = 'londonLocation',
}

export const OFFICE_LOCATION_CONTENT = {
  offices: [
    { locationI18Key: OfficeLocationsI18Keys.MELBOURNE, officeTitleI18Key: 'melbourneTitle', addressI18Key: 'melbourneAddress', imageId: 'q1tf7pylqjcf8a67j8ik' },
    { locationI18Key: OfficeLocationsI18Keys.SYDNEY, officeTitleI18Key: 'sydneyTitle', addressI18Key: 'sydneyAddress', imageId: '8an3e7vdvcrmwgu2z5qi' },
    { locationI18Key: OfficeLocationsI18Keys.CHADSTONE, officeTitleI18Key: 'chadstoneTitle', addressI18Key: 'chadstoneAddress', imageId: 'stfnt9kfcmt08sq4hbcj' },
    { locationI18Key: OfficeLocationsI18Keys.LONDON, officeTitleI18Key: 'londonTitle', addressI18Key: 'londonAddress', imageId: 'esabunbkcm1r1pdo3x8c' },
    { locationI18Key: OfficeLocationsI18Keys.SINGAPORE, officeTitleI18Key: 'singaporeTitle', addressI18Key: 'singaporeAddress', imageId: 'c2hnjcrf99m4xjrs16om' },
  ],
}

interface Props {
  selectedOffice: OfficeLocationsI18Keys;
}

function OfficeLocationModal(props: Props) {
  const { selectedOffice } = props
  const { t } = useTranslation('officeLocations')
  const selectedOfficeContent = OFFICE_LOCATION_CONTENT.offices.find(office => office.locationI18Key === selectedOffice) || OFFICE_LOCATION_CONTENT.offices[0]

  return (
    <ModalBase>
      <ModalHeader title={t(selectedOfficeContent.officeTitleI18Key, { ns: 'officeLocations' })} subtitle={t(selectedOfficeContent.addressI18Key, { ns: 'officeLocations' })} />
      <AspectRatio xs="2:1" sm="16:8">
        <Image id={selectedOfficeContent.imageId} fit="center" />
      </AspectRatio>
    </ModalBase>
  )
}

export default OfficeLocationModal
